import * as React from 'react';
import { assign as _assign} from 'lodash';
import { connect } from 'react-redux';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { GlobalPrivateState } from 'src/api';

export interface ConfigurationsDispatcherProps {
  userData: GlobalPrivateState['userData'];
  dispatch: any;
  queryState: GlobalPrivateState['queryState'];
  configurations: GlobalPrivateState['configurations'];
}

const dispatchKey = 'configurations';

class ConfigurationsDispatcherContainer extends React.Component<ConfigurationsDispatcherProps, any> {
  constructor(props: ConfigurationsDispatcherProps) {
    super(props);

    this.state = {
      tabsChecked: [props.queryState.params.tab]
    };
  }

  componentDidMount() {
    this.dispatchConfigurations();
  }

  public render() {
    return null;
  }

  componentDidUpdate(prevState: ConfigurationsDispatcherProps) {
    const prevSearch = prevState.queryState.search;
    const search = this.props.queryState.search;

    if (
      ((prevSearch && prevSearch.indexOf('sword') > -1) || (search && search.indexOf('sword') > -1)) 
        && prevSearch !== search
    ) {
      this.dispatchConfigurations();
    }
    if (
      ((prevSearch && prevSearch.indexOf('tab') > -1) || (search && search.indexOf('tab') > -1)) 
        && prevSearch !== search 
      // && !this.state.tabsChecked.includes(this.props.queryState.params.tab)
    ) {
      // this.dispatchConfigurations();

      // this.setState({
      //   tabsChecked: [...this.state.tabsChecked, this.props.queryState.params.tab]
      // });
    }
  }

  private dispatchConfigurations() {
    const queryParams: any = {
      skip: 0,
      limit: 20
    };

    if (this.props.queryState.params.sword) {
      queryParams.sword = this.props.queryState.params.sword;
    }

    if (this.props.queryState.params.tab) {
      queryParams.tab = this.props.queryState.params.tab;
    }

    // How to handle saving the previous configuration list... I was thinking to update the request npm but seems difficult...
    // Can I save the previous list here? Hmm
    this.props.dispatch(requestAPIActions.load<RequestApiHttpPayload>(
      dispatchKey, {
        url: `/Configurations/dashboard-list`,
        queryParams,
        isPager: true
      },
      true
    ));

    // I think the last "true" replaces the state... without it, it should just return the results somehow? or maybe it doesnt actually...
    // Okay, I can watch the change myself, and store the result into a separate state prop... so we have 1 for the api request, and 1 for the results... also I may not need to store in global state, just in the list

    // For pagination... yes I need isPager, 
  }
}

export const ConfigurationsDispatcher = connect((state: GlobalPrivateState) => ({
  configurations: state.configurations,
  queryState: state.queryState,
  userData: state.userData,
}))(ConfigurationsDispatcherContainer);
